export default {
  actions: {
    quotationList(ctx) {
      ctx.commit('updateQuotationList', [])
    },
    quotationDirectories(ctx) {
      ctx.commit('updateQuotationDirectories', null)
    }
  },
  mutations: {
    updateQuotationList(state, list) {
      state.quotationList = list
    },
    updateQuotationDirectories(state, directories) {
      state.quotationDirectories = directories
    }
  },
  state: {
    quotationList: [],
    quotationDirectories: null,
  },
  getters: {
    // getQuotationList(state) {
    //   return state.quotationList
    // },
    getQuotationDirectories(state) {
      return state.quotationDirectories
    }
  }
}